import type { SnippetsPluginOptions } from '@atlassian/editor-plugin-snippets';

import { createConfluenceSnippetsPluginOptions } from '../provider/confluenceSnippetsProvider.ts';

import { useOpenSnippetPanel } from './panel/useOpenSnippetPanel.ts';

export const useConfluenceSnippetsPluginOptions = (
	userId: string | undefined,
): SnippetsPluginOptions => {
	const openTemplateGallery = useOpenSnippetPanel();

	return createConfluenceSnippetsPluginOptions({
		getUserId: () => userId,
		openTemplateGallery,
	});
};
